"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItsModificationActionType = void 0;
var ItsModificationActionType;
(function (ItsModificationActionType) {
    ItsModificationActionType["Increase"] = "Increase";
    ItsModificationActionType["Decrease"] = "Decrease";
})(ItsModificationActionType = exports.ItsModificationActionType || (exports.ItsModificationActionType = {}));
